import { render, staticRenderFns } from "./TwoCube.vue?vue&type=template&id=0b7ba08a&scoped=true&"
import script from "./TwoCube.vue?vue&type=script&lang=js&"
export * from "./TwoCube.vue?vue&type=script&lang=js&"
import style0 from "./TwoCube.vue?vue&type=style&index=0&id=0b7ba08a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ba08a",
  null
  
)

export default component.exports